import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LooseObject } from '../../../../objects/loose-object';
import { blank, filled } from '../../../../shared/utils/common';
import { cloneDeep, get } from 'lodash-es';
import { sprintf } from 'sprintf-js';
import { ContractService } from '../../../../services/contract.service';
import { NotificationService } from '../../../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'asset-type-inspection-checklist',
  templateUrl: './asset-type-inspection-checklist.component.html',
})
export class AssetTypeInspectionChecklistComponent implements OnInit {

  arInspectionChecklist: LooseObject = [];

  bLoaded: boolean = false;

  intAssetQauantity: number = 1;

  get headerLabel(): string {
    return get(this.data, 'text', '');
  }

  selectAllChecklist: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: LooseObject,
    private matDialogRef: MatDialogRef<AssetTypeInspectionChecklistComponent>,
    private contractService: ContractService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {
    if (filled(get(this.data, 'id'))) {
      this._getInspectionChecklist();
    } else {
      this.bLoaded = true;
    }
  }

  ngOnInit() {
  }

  onSubmit(): void {
    let arChecklist = cloneDeep(this.arInspectionChecklist)
      .filter( item => item.is_checked == true )
      .map( item => {
        item.id = null;
        return {
          ...item,
          module: 'asset_types',
          quantity: this.intAssetQauantity,
          description: get(item, 'prompt_name'),
          asset_type_id: this.data.id
        };
      });

    if (filled(arChecklist)) {
      this.onCancelDialog(arChecklist);
    } else {
      this.notificationService.notifyWarning('no_selected_prompts');
    }
  }

  onCancelDialog(response: LooseObject[] = []): void {
    this.matDialogRef.close(response);
  }

  onChangeCheckbox(event, record: LooseObject, selectAll: boolean = false): void {
    let bChecked = event.currentTarget['checked'];
    if (selectAll) {

      this.arInspectionChecklist.map( item => {
        item.is_checked = bChecked;
      })
    } else {

      record.is_checked = bChecked;
      let arList = cloneDeep(this.arInspectionChecklist).filter( item =>
        item.is_checked == !bChecked && item.id != record.id
      );
      this.selectAllChecklist = bChecked == true && blank(arList);
    }
  }

  private _getInspectionChecklist(): void {
    this.contractService.getInspectionChecklist(this.data.id).subscribe( response => {
      let arItems = get(response, 'items');
      if (filled(arItems)) {
        if (arItems.length == 1) {
          this._setupChecklistInspection(response['items'][0]);
        }
        if (arItems.length > 1) {
          this.notificationService.notifyWarning('asset_type_has_more_than_one_active_checklist');
        }
      }
      this.bLoaded = true;
    });
  }

  /**
   * setup checklist inspection based on selected asset type
   *
   * @param checklistInspection
   */
  private _setupChecklistInspection(checklistInspection: LooseObject): void {
    const promptsConfig = get(checklistInspection, 'group_prompts_configuration');
    const questions = get(checklistInspection, 'questions', []);
    questions.forEach( question => {
      question.prompts.forEach( prompt => {

        const promptId = get(prompt, 'id');
        if (prompt.is_group && prompt.available_period != 'always') {

          const promptConfig = get(promptsConfig, promptId, {});
          this.arInspectionChecklist.push({
            id: prompt.id,
            prompt_name: sprintf('%s (%s)', prompt.group_name, this._translatePeriod(prompt.available_period)),
            is_checked: false,
            repeated_every: prompt.available_period,
            unit_price: get(promptConfig, 'prompt_unit_price', 0.00),
          });
        }
      });
    });
  }

  /**
   * translate checklist inspection period
   */
  private _translatePeriod(period): string {
    const arPeriod = period.split('_');
    let strTranslatedPeriod = period;
    if (filled(arPeriod[1]) && typeof arPeriod[1] === 'string') {

      strTranslatedPeriod = sprintf('%s %s', arPeriod[0], this.translateService.instant(arPeriod[1]));
    }

    return strTranslatedPeriod;
  }
}
